const CUSTOM_WIDGET_ITEM_ID = "pa-instock-sdk-custom-widget";
export {
  CUSTOM_WIDGET_ITEM_ID
};
